import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { label: "About Us", href: "/about" },
    { label: "Our Services", href: "/services" },
    { label: "Our Products", href: "/products" },
    { label: "Contact Us", href: "/contact" },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#0d0d0d]/96 backdrop-blur-md border-b border-white/[0.06]"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link
            to="/"
            className="flex items-center gap-3"
          >
            <span
              className="text-base font-bold tracking-[0.16em] text-white uppercase"
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            >
              Trevionix
            </span>
            <span className="w-px h-4 bg-white/20" />
            <span
              className="text-[11px] tracking-[0.12em] text-[#6C7278] uppercase"
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            >
              LTD
            </span>
          </Link>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-10">
            {navLinks.map((link) =>
              link.href.startsWith("/") ? (
                <Link
                  key={link.label}
                  to={link.href}
                  className="text-[11px] uppercase tracking-[0.18em] text-[#6C7278] hover:text-white transition-colors duration-300"
                  style={{ fontFamily: "'Space Grotesk', sans-serif" }}
                >
                  {link.label}
                </Link>
              ) : (
                <a
                  key={link.label}
                  href={isHome ? link.href : `/${link.href}`}
                  className="text-[11px] uppercase tracking-[0.18em] text-[#6C7278] hover:text-white transition-colors duration-300"
                  style={{ fontFamily: "'Space Grotesk', sans-serif" }}
                >
                  {link.label}
                </a>
              )
            )}
          </div>

          {/* Desktop actions */}
          <div className="hidden md:flex items-center gap-4">
            <Link
              to="/contact"
              className="text-[11px] uppercase tracking-[0.12em] text-white border border-white/20 px-5 py-2 hover:bg-white hover:text-[#1A1C1E] transition-all duration-300 whitespace-nowrap"
              style={{ fontFamily: "'Space Grotesk', sans-serif", borderRadius: "4px" }}
            >
              Get Started
            </Link>
          </div>

          {/* Mobile toggle */}
          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-white"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <i className={`ri-${mobileMenuOpen ? "close" : "menu"}-line text-xl`} />
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-[#0d0d0d]/98 backdrop-blur-md border-t border-white/[0.06]">
          <div className="px-6 py-5 flex flex-col gap-1">
            {navLinks.map((link) =>
              link.href.startsWith("/") ? (
                <Link
                  key={link.label}
                  to={link.href}
                  className="text-xs uppercase tracking-[0.15em] text-[#6C7278] hover:text-white py-3 border-b border-white/[0.04] transition-colors"
                  style={{ fontFamily: "'Space Grotesk', sans-serif" }}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {link.label}
                </Link>
              ) : (
                <a
                  key={link.label}
                  href={isHome ? link.href : `/${link.href}`}
                  className="text-xs uppercase tracking-[0.15em] text-[#6C7278] hover:text-white py-3 border-b border-white/[0.04] transition-colors"
                  style={{ fontFamily: "'Space Grotesk', sans-serif" }}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {link.label}
                </a>
              )
            )}
            <div className="pt-4">
              <a
                href="tel:+447520658798"
                className="text-xs text-[#6C7278]"
                style={{ fontFamily: "'Space Grotesk', sans-serif" }}
              >
                <i className="ri-phone-line mr-1.5" />
                +44 7520 658798
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}
